import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getIdSummary,
} from "./resultAPI";

const initialState = {
  data: [],
  dataId: null,
  dataSummary: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "result/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchResult = createAsyncThunk(
  "result/fetchResult",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("result/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdSummary = createAsyncThunk(
  "result/fetchIdSummary",
  async (id) => {
    const response = await getIdSummary(id);
    return response;
  }
);

export const fetchIdNoloading = createAsyncThunk(
  "result/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("result/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("result/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "result/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const resultSlice = createSlice({
  name: "result",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchResult.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchResult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = resultSlice.actions;

export const selectData = (state) => state.result.data;
export const selectDataResult = (state) => state.result.data;
export const selectId = (state) => state.result.dataId;
export const selectLoading = (state) => state.result.loading;
export const selectError = (state) => state.result.error;
export const selectPageNo = (state) => state.result.pageNo;
export const selectPageSize = (state) => state.result.pageSize;
export const selectTotalRecord = (state) => state.result.totalRecord;
export const selectSelected = (state) => state.result.selected;
export const selectResult = (state) => state.result.result;

export default resultSlice.reducer;
